import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function EarlyAccessDialog({
  open,
  onContinue,
  onDetails,
  error,
}) {
  return (
    <Dialog
      open={open}
      onClose={onContinue}
      aria-labelledby="early-access-dialog-title"
      fullWidth
      maxWidth="sm"
      data-testid="early-access-dialog"
    >
      <DialogTitle id="early-access-dialog-title">
        JourneyBot is in Early Access
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body1">
            JourneyBot is still under active development and is not yet considered production-grade.
            Features may change, and you may encounter errors, interruptions or data loss.
          </Typography>
          <Typography variant="body1">
            Please keep copies of important information and do not rely on JourneyBot as the only
            record of critical decisions or documents.
          </Typography>
          {error ? (
            <Alert severity="warning" data-testid="early-access-acknowledgement-error">
              {error}
            </Alert>
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDetails} data-testid="early-access-details">
          View Early Access details
        </Button>
        <Button variant="contained" color="warning" onClick={onContinue} data-testid="early-access-continue" autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
